// extracted by mini-css-extract-plugin
export default {"root":"GPHeR","container":"_1W_lr","title":"_3Xtrt","icon":"JomVa"};